import { makeStyles } from "@material-ui/core/styles";
export default theme => ({});


export const BlackTooltip = makeStyles((theme) => ({
	arrow: {
		color: theme.palette.yokogawaColors.black,
	},
	tooltip: {
		maxWidth: 550,
		backgroundColor: theme.palette.yokogawaColors.black,
		fontFamily: "NotoSans-Regular",
		fontSize: 14,
	},
}));